import { render, staticRenderFns } from "./M5Error.vue?vue&type=template&id=94d90510&"
import script from "./M5Error.vue?vue&type=script&lang=js&"
export * from "./M5Error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports